/**
 * 動詞の一覧（`/verbs`）。名前だけを全件出す。
 *
 * 動詞は業務・業務ルール・画面・ステージの名前の後ろ半分を作る語の集合である。一覧の問いは
 * 「どの動詞が使えるか（目当ての動詞を開く）」なので、名詞形と層は一覧に添えず、動詞の詳細の
 * 欄で読む（Dhik 2026-09-29「本当に出すべき情報を 1 or 2 個に」）。
 *
 * @graph-stack spec-console
 * @graph-domain Engineering
 * @graph-business 動詞を名前だけで全件一覧し、マスター詳細へ繋ぐ。
 * @graph-connects useListMasters [calls] 動詞一覧の取得
 * @graph-connects MasterTableListPage [calls] 名前の一覧の本体
 */
import { useSearch } from '@tanstack/react-router';

import { useListMasters } from '../hooks/queries/spec-graph-element-master-queries.js';
import { MasterTableListPage } from './master-table-list.js';
import { pjTextOf } from './pj-search.js';
import { VERBS_ROUTE } from './route-paths.js';

/**
 * @graph-node {Function}
 * @graph-stack spec-console
 * @graph-domain Engineering
 * @graph-business 動詞の一覧を、名前の 1 列の表で描く。
 * @graph-connects useListMasters [calls] 動詞一覧の取得
 * @graph-connects pjTextOf [calls] 検索条件の案件番号を文字列へ戻す
 */
export function VerbsPage() {
  const pj = pjTextOf(useSearch({ from: VERBS_ROUTE }).pj);
  const { data, isLoading, error } = useListMasters('verb', pj);

  return (
    <MasterTableListPage
      type="verb"
      titleKey="verbs.title"
      nameKey="verbs.columnName"
      emptyKey="verbs.empty"
      items={data?.items}
      isLoading={isLoading}
      error={error}
      pj={pj}
    />
  );
}
